import { API_ROUTES } from '@/api/apiRoutes';
import { safeAxios } from '@/services/safeAxios';
import type { BuiltInModelResponse } from '@/types/api/builtInModel';

export const getFalModel = async (falUrl: string) => {
  const res = await safeAxios.post<
    { name: string; schema: Record<string, any>; version: string } | BuiltInModelResponse
  >(API_ROUTES.models.falModel(), { url: falUrl });
  return res.data;
};
